import React from 'react';

interface TriquetraIconProps {
  size?: number;
  className?: string;
}

/**
 * Triquetra (the classic three-petal interlaced "trinity knot"), variant A:
 * petals only, no surrounding circle. Drawn as a monochrome inline SVG so it
 * inherits `currentColor` and hover states, matching the site's other custom
 * icons (TelegramIcon, RedditIcon, ...).
 *
 * Geometry (viewBox 0 0 100 100, centre 50,50): a single vesica-piscis "petal"
 * is defined once, then rotated 120 deg and 240 deg about the centre, giving
 * exact 3-fold rotational symmetry by construction. Each petal is two circular
 * arcs of equal radius (r=32) meeting at a pointed outer tip 40 units above the
 * centre and an inner tip 13 units past the centre; the past-centre overlap of
 * the three petals forms the interlaced central triangle. Stroke-based with
 * round joins for a clean, premium line-art read at small sizes.
 */
export const TriquetraIcon: React.FC<TriquetraIconProps> = ({ size = 20, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    stroke="currentColor"
    strokeWidth={6.5}
    strokeLinejoin="round"
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M50 10 A32 32 0 0 1 50 63 A32 32 0 0 1 50 10 Z" />
    <path d="M50 10 A32 32 0 0 1 50 63 A32 32 0 0 1 50 10 Z" transform="rotate(120 50 50)" />
    <path d="M50 10 A32 32 0 0 1 50 63 A32 32 0 0 1 50 10 Z" transform="rotate(240 50 50)" />
  </svg>
);

export default TriquetraIcon;
